import { Modal, styled } from "@mui/material";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

const Root = styled("div")(({ theme }) => ({
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#ffffff",
  position: "absolute",
  borderRadius: "16px",
  outline: "none !important",
  padding: "10px",
  width: isMobile ? 320 : 600,
  border: "1px solid #1E90FF",

  ".bank-item": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "12px",
    fontWeight: "bold",
    background: "#1875CC",
    borderRadius: "14px",
    padding: "10px",
    color: "white",
  },
}));

const ChooseBuyModeMobile = ({ open, setOpen, data, setReadyToBy }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        "& .MuiBackdrop-root": {
          border: "none",
        },
        "& .MuiPaper-root": {
          border: "none",
        },
      }}
    >
      <Root>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <div
            style={{
              opacity: data?.hasBuyOnline ? 1 : 0.5,
              width: "100%",
            }}
          >
            <div
              className="bank-item"
              onClick={() =>
                data.hasBuyOnline &&
                !data?.outOfStock &&
                setReadyToBy({
                  open: true,
                  type: "BOGBUY",
                })
              }
            >
              <img
                src={"/assets/bank/bog.png"}
                width={20}
                alt={"online buy bog"}
              />
              {t("buyBog")}
            </div>
          </div>

          <div
            style={{
              opacity: data?.hasBogInstallment ? 1 : 0.5,
              width: "100%",
            }}
          >
            <div
              className="bank-item"
              onClick={() =>
                data.hasBuyOnline &&
                !data?.outOfStock &&
                setReadyToBy({
                  open: true,
                  type: "BOGINSTALLMENT",
                })
              }
            >
              <img
                src={"/assets/bank/bog.png"}
                width={20}
                alt={"installment bog"}
              />
              {t("bogInstallment")}
            </div>
          </div>

          <div
            style={{
              opacity: data?.hasTbcInstallment ? 1 : 0.5,
              width: "100%",
            }}
          >
            <div
              className="bank-item"
              onClick={() =>
                data.hasBuyOnline &&
                !data?.outOfStock &&
                setReadyToBy({
                  open: true,
                  type: "TBCINSTALLMENT",
                })
              }
            >
              <img
                src={"/assets/bank/tbc.png"}
                width={20}
                alt={"installment tbc"}
              />
              {t("tbcInstallment")}
            </div>
          </div>

          <div
            style={{
              opacity: data?.hasCredoInstallment ? 1 : 0.5,
              width: "100%",
            }}
          >
            <div
              className="bank-item"
              onClick={() =>
                data.hasBuyOnline &&
                !data?.outOfStock &&
                setReadyToBy({
                  open: true,
                  type: "CREDOINSTALLMENT",
                })
              }
            >
              <img
                src={"/assets/bank/kredo.png"}
                width={20}
                alt={"installment credo"}
              />
              {t("credoInstallment")}
            </div>
          </div>
        </div>
      </Root>
    </Modal>
  );
};

export default ChooseBuyModeMobile;
